import React from 'react';
import { View, StyleSheet, ActivityIndicator, Text, AppState } from 'react-native';
import { connect } from 'react-redux';
import { Button, ButtonTypes } from '../components';
import { LogoutHelper } from 'fitbeat.react-native-components';
import Theme from '../theme';
import { UserDataConsumer } from '../utils';
import { openMembershipPlans } from './utils';

class ExternalPlanSelection extends React.Component {
  state = {
    isLoading: false,
    message: 'To activate your Fitillion membership, please select a plan',
    appState: AppState.currentState,
  };

  noPlanSelected = () => {
    this.setState({
      isLoading: false,
      message: 'No plan selected. To activate your Fitillion membership, please select a plan.',
    });
  }

  handleAppStateChange = async (nextAppState) => {
    const appCameFromBackground = this.state.appState.match(/inactive|background/) && nextAppState === 'active';
    if (appCameFromBackground) {
      const timeoutToStopUiFlashingIfPlanIsSelected = 2000;
      setTimeout(this.noPlanSelected, timeoutToStopUiFlashingIfPlanIsSelected);
    }
    this.setState({ appState: nextAppState });
  }

  async componentDidMount() {
    this.navigatToPaymentIfPlanIsPresent();
    AppState.addEventListener('change', this.handleAppStateChange);
  }

  componentDidUpdate = () => {
    this.navigatToPaymentIfPlanIsPresent();
  }

  componentWillUnmount = () => {
    AppState.removeEventListener('change', this.handleAppStateChange);
  }

  navigatToPaymentIfPlanIsPresent = () => {
    const {
      planId,
      email,
    } = this.props;
    if (planId) {
      this.props.navigation.navigate('PreLoadedPlanDetails');
    }
  };

  openExternalPlansPage = async () => {
    await this.setState({ isLoading: true });
    const { userProfile } = this.props;
    await openMembershipPlans(userProfile)
  };

  logout = async () => {
    await LogoutHelper();
  }

  render() {
    const { isLoading } = this.state;
    return (
      <View style={styles.container}>
        <Text style={styles.text}>
          {this.state.message}
        </Text>
        {isLoading ?
          <ActivityIndicator
            size="small"
            color={Theme.PRIMARY}
            animating={isLoading}
            style={styles.activityIndicator}
          />
          :
          <>
            <Button
              fontColor={Theme.WHITE}
              title={'See Membership Plans'}
              onPress={this.openExternalPlansPage}
            />
            <Button
              fontColor={Theme.PRIMARY}
              buttonType={ButtonTypes.OUTLINE}
              title={'Logout'}
              onPress={this.logout}
              containerStyle={styles.logoutButton}
            />
          </>
        }
      </View>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    planId: state.deepLinkParamaters.planId,
    coupon: state.deepLinkParamaters.coupon,
    email: ownProps.navigation.getParam('email', null),
    userProfile: ownProps.user.userProfile,
  };
};
const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Theme.WHITE,
    padding: 5
  },
  text: {
    fontSize: 18,
    color: Theme.GREY_MEDIUM,
    fontFamily: Theme.Custom700,
    padding: 10,
    paddingBottom: 15,
  },
  logoutButton: {
    marginTop: 5,
  },
  activityIndicator: {
    paddingVertical: 10,
  }
});

ExternalPlanSelection = connect(mapStateToProps)(ExternalPlanSelection);
export default UserDataConsumer(ExternalPlanSelection);
